import { defineComponent as _defineComponent } from 'vue'
import { useVerticalSlider } from "@/composables/shared/useVerticalSlider";
import { ref, computed, onMounted, watch, toRefs } from "vue";


const __default__ = {
  name: "VerticalSlider",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Number,
    default: 0,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 1,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const THUMB_SIZE = 10;

const props = __props;

const { modelValue, min, max } = toRefs(props);

const emit = __emit;

// composable 호출 (min/max 는 Ref)
const { value, thumbBottomPx, updateFromY } = useVerticalSlider({
  min,
  max,
  thumbSize: THUMB_SIZE,
});

watch(
  modelValue,
  (v) => {
    value.value = v;
  },
  { immediate: true }
);

watch(value, (v) => {
  emit("update:modelValue", v);
});

// slider 높이 측정
const slider = ref<HTMLElement | null>(null);
const containerHeight = ref(0);
onMounted(() => {
  if (slider.value) containerHeight.value = slider.value.clientHeight;
});

// thumb bottom 계산: 끝점은 0px/100%-thumbSize, 중간은 픽셀
const thumbBottom = computed(() => {
  if (!containerHeight.value) return "0px";
  if (value.value <= min.value) return "0px";
  if (value.value >= max.value) return `calc(100% - ${THUMB_SIZE}px)`;
  return `${thumbBottomPx(containerHeight.value)}px`;
});

// 드래그 로직
const dragging = ref(false);
function onPointerDown(e: PointerEvent) {
  e.preventDefault();
  dragging.value = true;
  if (!slider.value) return;
  updateFromY(e.clientY, slider.value.getBoundingClientRect());

  const onMove = (e: PointerEvent) => {
    if (!dragging.value || !slider.value) return;
    updateFromY(e.clientY, slider.value.getBoundingClientRect());
  };
  const onUp = () => {
    dragging.value = false;
    window.removeEventListener("pointermove", onMove);
    window.removeEventListener("pointerup", onUp);
  };
  window.addEventListener("pointermove", onMove);
  window.addEventListener("pointerup", onUp);
}

const focused = ref(false);
function onFocus() {
  focused.value = true;
}
function onBlur() {
  focused.value = false;
}

function onKeyDown(e: KeyboardEvent) {
  if (e.key === "ArrowUp" || e.key === "ArrowRight") {
    value.value = Math.min(max.value, value.value + 1);
    e.preventDefault();
  } else if (e.key === "ArrowDown" || e.key === "ArrowLeft") {
    value.value = Math.max(min.value, value.value - 1);
    e.preventDefault();
  } else if (e.key === "Home") {
    value.value = min.value;
    e.preventDefault();
  } else if (e.key === "End") {
    value.value = max.value;
    e.preventDefault();
  }
}

const __returned__ = { THUMB_SIZE, props, modelValue, min, max, emit, value, thumbBottomPx, updateFromY, slider, containerHeight, thumbBottom, dragging, onPointerDown, focused, onFocus, onBlur, onKeyDown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})